// extracted by mini-css-extract-plugin
export default {"head":"Products_head__YWmOw","title":"Products_title__YbL5Y","wrapper":"Products_wrapper__i3LUA","empty":"Products_empty__8SIT-","card":"Products_card__qIjuq"};